"use strict";
const _ = require('lodash');
const moment = require('moment');
const articleModel = require('../article');
const { alcoholTaxCalculator } = require('../article/alcohol-tax-calculator');
const { pantArticleLow, pantArticleHigh, } = require('../article/special-articles');
const { removeSpecialRows, getSRSRows, } = require('../../interfaces/orderAndInvoiceRows/collections');
const { getUnitOnRow, calculateTotalForRow, } = require('../../interfaces/orderAndInvoiceRows/properties');
const { srsEUR6PalletArticle, requiresEMCS } = require('../article');
const { VINDEN_ORDER_FULLFILLMENT_CENTER_ID, } = require('../orderFullfillmentCenter');
const { getAlcTaxCancellingRows, getHandlingCostRows, } = require('./properties');
const { zipToMapMap } = require('../../maps');
const SRS_EUR6_COST = 200;
function createSRSRows(order) {
    return [
        {
            id: _.uuid(),
            name: srsEUR6PalletArticle.name,
            price: SRS_EUR6_COST,
            unit: 'single',
            deliveredQuantity: order.deliveryPalletTypes.filter(x => x === 'SRS_EUR6')
                .length,
            orderedQuantity: order.deliveryPalletTypes.length,
            article: srsEUR6PalletArticle,
            total: SRS_EUR6_COST,
            lookups: {
                article: {
                    articleNumber: srsEUR6PalletArticle.articleNumber,
                    owningSupplierOrganizationId: null,
                },
            },
        },
    ];
}
function mergeAndKeepId(newArray, oldArray) {
    return newArray.map(x => {
        const exists = oldArray.find(c => c.article.articleNumber === x.article.articleNumber);
        if (exists) {
            return { ...x, id: exists.id };
        }
        return { ...x };
    });
}
const isNotSpecialNorUtilityArticle = article => {
    if (!article) {
        return false;
    }
    if (articleModel.isSpecialArticle(article)) {
        return false;
    }
    if (article.utilityArticle) {
        return false;
    }
    return true;
};
class Invariantor {
    constructor(orderToEnsure) {
        const orderRows = orderToEnsure.orderRows || [];
        this.articleRows = [];
        this.handlingCostRows = [];
        this.SRSRows = [];
        this.alcTaxCancellingRow = [];
        this.order = orderToEnsure;
        this.alcTaxCancellingRows = getAlcTaxCancellingRows(orderRows);
        this.handlingCostRows = getHandlingCostRows(orderRows);
        this.SRSRows = getSRSRows(orderRows);
        this.articleRows = removeSpecialRows(orderRows);
    }
    ensureQuantities() {
        const fixQuantities = row => ({
            ...row,
            deliveredQuantity: row.deliveredQuantity || 0,
            orderedQuantity: row.orderedQuantity || 0,
            alcoholTax: row.alcoholTax || 0,
        });
        this.articleRows = this.articleRows.map(fixQuantities);
        this.alcTaxCancellingRows = this.alcTaxCancellingRows.map(fixQuantities);
        this.handlingCostRows = this.handlingCostRows.map(fixQuantities);
        this.SRSRows = this.SRSRows.map(fixQuantities);
        return this;
    }
    ensureLabels() {
        const labels = [];
        if (this.order.supplierCustomer && this.order.supplierCustomer.labels) {
            labels.push(...this.order.supplierCustomer.labels);
        }
        this.articleRows.forEach(articleRow => {
            if (articleRow.article && articleRow.article.labels) {
                labels.push(...articleRow.article.labels);
            }
        });
        this.order.labels = _.sortBy(_.uniqBy(labels, 'id'), 'name');
        return this;
    }
    ensureSupplierUnit() {
        this.articleRows = this.articleRows.map(x => ({
            ...x,
            supplierUnit: x.article && x.article.supplierOrderUnit,
        }));
        return this;
    }
    ensureDeliveryDate() {
        if (this.order.deliveryDate && !this.order.requestedDeliveryDate) {
            this.order.requestedDeliveryDate = this.order.deliveryDate;
        }
        if (this.order.requestedDeliveryDate && !this.order.deliveryDate) {
            this.order.deliveryDate = this.order.requestedDeliveryDate;
        }
        return this;
    }
    // IMPORTANT remember to also change pant.js inside supplierSalesReport
    ensurePantRows() {
        const shouldHavePant = !_.includes(['returnToSupplier'], this.order.orderOrigin);
        // As soon as we dont have pantrows in the system anymore. removing pantrows can soon be deleted
        this.articleRows = this.articleRows
            .filter(x => _.get(x, 'article.articleNumber') !== pantArticleLow.articleNumber &&
            _.get(x, 'article.articleNumber') !== pantArticleHigh.articleNumber)
            .map(x => ({
            ...x,
            totalRecycle: x.article &&
                x.article.recycleAmount &&
                shouldHavePant &&
                x.discount !== 100
                ? x.article.recycleAmount * x.deliveredQuantity
                : 0,
        }));
        return this;
    }
    ensureAlcTaxInRows() {
        if (this.order.requiresEMCS) {
            return this;
        }
        this.articleRows = this.articleRows.map(x => ({
            ...x,
            alcoholTax: alcoholTaxCalculator(x.article) * (x.deliveredQuantity || 0),
        }));
        return this;
    }
    ensureOrderDate() {
        if (this.order.orderDate) {
            return this;
        }
        this.order = {
            ...this.order,
            orderDate: moment().format('YYYY-MM-DD'),
        };
        return this;
    }
    ensureOrderCurrency() {
        if (!_.has(this.order, 'orderRows[0]') ||
            !_.has(this.order.orderRows[0], 'article')) {
            this.order.currency = null;
            return this;
        }
        this.order = {
            ...this.order,
            currency: this.order.currency ||
                _.get(this.order, 'orderRows[0].article.currency', 'SEK'),
        };
        return this;
    }
    ensureSRSRows() {
        if (!_.includes(this.order.deliveryPalletTypes, 'SRS_EUR6')) {
            this.SRSRows = [];
            return this;
        }
        this.SRSRows = mergeAndKeepId(createSRSRows(this.order), this.SRSRows);
        return this;
    }
    ensureRowPriceAndTotal() {
        const isReturnToSupplierOrder = this.order.orderOrigin === 'returnToSupplier';
        const { shouldHaveVAT } = this.order;
        this.articleRows = this.articleRows.map(x => {
            let newRow = { ...x };
            if (x.article) {
                newRow = {
                    ...newRow,
                    name: x.article.name,
                    unit: getUnitOnRow(x),
                    VAT: shouldHaveVAT ? x.article.VAT : 0,
                    accountNumber: x.article.salesAccount,
                };
            }
            const articlePriceList = _.get(x, 'article.priceList');
            if (articlePriceList) {
                newRow = {
                    ...newRow,
                    priceList: articlePriceList,
                };
            }
            if (isReturnToSupplierOrder) {
                newRow = {
                    ...newRow,
                    price: 0,
                    total: 0,
                    discount: 0,
                    totalIncludingRecycle: 0,
                };
            }
            else {
                newRow = {
                    ...newRow,
                    total: calculateTotalForRow(x),
                    totalIncludingRecycle: calculateTotalForRow(x) + x.totalRecycle,
                };
            }
            return newRow;
        });
        return this;
    }
    ensureOrdernumberIsCopiedToYourOrderNumberIfChainIsAxfood() {
        if (this.order.customerSubUnit &&
            _.startsWith(this.order.customerSubUnit.chain, 'Axfood') &&
            this.order.customerSubUnit.emailInvoice === 'send_electronic@crediflow.se') {
            this.order.yourOrderNumber = this.order.orderNumber;
        }
        return this;
    }
    // TODO we can update the eventsource so we no longer nee dto run this code
    ensureOldOrderOrigins() {
        if (this.order.orderOrigin === 'dropshipping') {
            this.order.orderOrigin = 'customer';
        }
        if (this.order.orderOrigin === 'export') {
            this.order.orderOrigin = 'supplier';
        }
        return this;
    }
    ensureRoundedQuantities() {
        this.articleRows = this.articleRows.map(x => {
            const res = { ...x };
            if (x.deliveredQuantity) {
                res.deliveredQuantity = _.round(x.deliveredQuantity, 3);
            }
            if (x.orderedQuantity) {
                res.orderedQuantity = _.round(x.orderedQuantity, 3);
            }
            return res;
        });
        return this;
    }
    ensureEndCustomerInformation() {
        const { customerSubUnit, supplierCustomer } = this.order;
        if (this.order.orderOrigin === 'systembolaget') {
            return this;
        }
        const customer = supplierCustomer || customerSubUnit;
        if (!customer) {
            return this;
        }
        this.order = {
            ...this.order,
            deliveryName: customer.deliveryName || this.order.deliveryName,
            deliveryAddress: customer.deliveryAddress || this.order.deliveryAddress,
            deliveryAddress2: customer.deliveryAddress2 || this.order.deliveryAddress2,
            deliveryCity: customer.deliveryCity || this.order.deliveryCity,
            deliveryZipCode: customer.deliveryZipCode || this.order.deliveryZipCode,
            deliveryCountry: customer.deliveryCountry || this.order.deliveryCountry,
            invoiceAddress: customer.invoiceAddress || this.order.invoiceAddress,
            invoiceAddress2: customer.invoiceAddress2 || this.order.invoiceAddress2,
            invoiceCity: customer.invoiceCity || this.order.invoiceCity,
            invoiceZipCode: customer.invoiceZipCode || this.order.invoiceZipCode,
            invoiceCountry: customer.invoiceCountry || this.order.invoiceCountry,
            termsOfPayment: customer.termsOfPayment || this.order.termsOfPayment,
            email: this.order.email || customer.email,
            phone: this.order.phone || customer.phone,
            yourReference: this.order.yourReference || customer.yourReference,
            organisationNumber: customer.organisationNumber || this.order.organisationNumber,
            deliveryCounty: zipToMapMap(customer.deliveryZipCode || this.order.deliveryZipCode),
        };
        return this;
    }
    ensureOrderFlowType() {
        if (this.order.orderFullfillmentCenter) {
            this.order.orderFlowType =
                this.order.orderFullfillmentCenter.orderFlowType;
        }
        return this;
    }
    ensureOrderFullfillmentCenter() {
        if (this.order.orderOrigin === 'stockfiller') {
            if (_.get(this.order, 'orderFullfillmentCenter.id') !==
                VINDEN_ORDER_FULLFILLMENT_CENTER_ID) {
                this.order.orderFullfillmentCenter = {
                    id: VINDEN_ORDER_FULLFILLMENT_CENTER_ID,
                    isCopack: true,
                };
            }
        }
        if (this.order.supplierCustomer &&
            this.order.supplierCustomer.orderFullfillmentCenter &&
            !this.order.orderFullfillmentCenter) {
            this.order.orderFullfillmentCenter =
                this.order.supplierCustomer.orderFullfillmentCenter;
        }
        return this;
    }
    ensureOrderOwningSupplierOrganization() {
        this.articleRows = this.articleRows.map(x => ({
            ...x,
            owningSupplierOrganizationId: x.article
                ? x.article.owningSupplierOrganizationId
                : x.owningSupplierOrganizationId,
        }));
        const owners = _(this.articleRows)
            .filter(x => isNotSpecialNorUtilityArticle(x.article))
            .uniqBy(x => x.owningSupplierOrganizationId)
            .value();
        if (owners.length === 1) {
            this.order.owningSupplierOrganizationId =
                _.first(owners).owningSupplierOrganizationId;
        }
        else if (owners.length > 1) {
            this.order.owningSupplierOrganizationId = null;
        }
        return this;
    }
    ensureQuantityBasedOnSKU() {
        this.articleRows = this.articleRows.map(x => {
            const updatedRow = { ...x };
            if (x.orderedSKU) {
                updatedRow.orderedQuantity =
                    x.orderedSKU.quantityOfMainUnitPerUnit * x.orderedSKUQuantity;
                if (x.orderedSKU.unit === 'kg') {
                    updatedRow.unit = 'weight';
                }
                else {
                    updatedRow.unit = 'single';
                }
            }
            if (x.deliveredSKU) {
                updatedRow.deliveredQuantity =
                    x.deliveredSKU.quantityOfMainUnitPerUnit * x.deliveredSKUQuantity;
            }
            return updatedRow;
        });
        return this;
    }
    ensurePriceBasedOnSKU() {
        this.articleRows = this.articleRows.map(x => {
            const updatedRow = { ...x };
            if (x.deliveredSKU &&
                x.deliveredSKU.quantityOfMainUnitPerUnit &&
                x.deliveredSKUPrice) {
                updatedRow.price = _.round(x.deliveredSKUPrice / x.deliveredSKU.quantityOfMainUnitPerUnit, 2);
            }
            return updatedRow;
        });
        return this;
    }
    ensureRequiresEmcs() {
        const { customerSubUnit, supplierCustomer } = this.order;
        const articleRequiresEMCS = this.articleRows
            .filter(x => x.article)
            .some(row => requiresEMCS(row.article));
        const customerHasExciseNumber = !!((customerSubUnit && customerSubUnit.exciseNumber) ||
            (supplierCustomer && supplierCustomer.exciseNumber));
        this.order.requiresEMCS = articleRequiresEMCS && customerHasExciseNumber;
        return this;
    }
    ensureShouldHaveVAT() {
        const { supplierCustomer } = this.order;
        const VATType = _.get(supplierCustomer, 'customFields.VATType');
        if (!VATType) {
            this.order.shouldHaveVAT = true;
        }
        if (_.includes(['SEVAT', 'EUVAT'], VATType)) {
            this.order.shouldHaveVAT = true;
        }
        if (_.includes(['SEREVERSEDVAT', 'EUREVERSEDVAT', 'EXPORT'], VATType)) {
            this.order.shouldHaveVAT = false;
        }
        return this;
    }
    value() {
        return {
            ...this.order,
            orderRows: [
                ...this.articleRows,
                ...this.alcTaxCancellingRow,
                ...this.handlingCostRows,
                ...this.SRSRows,
            ],
        };
    }
}
// invariants for the entity goes here
module.exports = orderToEnsure => {
    const hadRows = !!orderToEnsure.orderRows;
    const ensured = new Invariantor(orderToEnsure)
        .ensureShouldHaveVAT()
        .ensureQuantityBasedOnSKU() // can be removed when orderRow.unit is removed
        .ensurePriceBasedOnSKU() // can be removed when orderRow.price is removed
        .ensureQuantities()
        .ensureSupplierUnit()
        .ensurePantRows()
        .ensureAlcTaxInRows()
        .ensureRowPriceAndTotal()
        .ensureSRSRows()
        .ensureEndCustomerInformation()
        .ensureOrderFullfillmentCenter()
        .ensureOrderOwningSupplierOrganization()
        .ensureOrderDate()
        .ensureOrderCurrency()
        .ensureOldOrderOrigins()
        .ensureRoundedQuantities()
        .ensureDeliveryDate()
        .ensureLabels()
        .ensureOrdernumberIsCopiedToYourOrderNumberIfChainIsAxfood()
        .ensureOrderFlowType()
        .ensureRequiresEmcs()
        .value();
    if (!hadRows) {
        delete ensured.orderRows;
    }
    return ensured;
};
